import { Assert } from '@team/assert';

const METERS_IN_KM = 1_000;

export const toKm = (languageCode = 'en') => {
  const formatter = new Intl.NumberFormat(languageCode, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (value: number) => {
    if (!Assert.isNumber(value)) {
      return String(value);
    }

    const kilometers = value / METERS_IN_KM;

    return formatter.format(kilometers);
  };
};
